import type { StateCreator } from 'zustand';

export interface WhatsNewSlice {
  lastSeenVersion: string | null;
  setLastSeenVersion: (version: string) => void;
}

export const CURRENT_CHANGELOG_VERSION = '2026-11-02';

export const createWhatsNewSlice: StateCreator<
  WhatsNewSlice,
  [],
  [],
  WhatsNewSlice
> = (set) => ({
  lastSeenVersion: null,
  setLastSeenVersion: (version) => set({ lastSeenVersion: version }),
});
